"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PurchaseCompleteBenefitIcon = PurchaseCompleteBenefitIcon;
var _react = _interopRequireDefault(require("react"));
var _iAvatar = _interopRequireDefault(require("images/purchase-complete-account-activation/i-avatar.webp"));
var _iCart = _interopRequireDefault(require("images/purchase-complete-account-activation/i-cart.webp"));
var _iCard = _interopRequireDefault(require("images/purchase-complete-account-activation/i-card.webp"));
// The source asset filenames are crossed: i-cart contains cards and i-card contains a cart.

var ICON_BY_TYPE = {
  card: _iCart["default"],
  cart: _iCard["default"],
  profile: _iAvatar["default"]
};
function PurchaseCompleteBenefitIcon(_ref) {
  var className = _ref.className,
    type = _ref.type;
  return /*#__PURE__*/_react["default"].createElement("img", {
    alt: "",
    "aria-hidden": "true",
    className: className,
    height: "24",
    src: ICON_BY_TYPE[type],
    width: "24",
    "data-sentry-component": "PurchaseCompleteBenefitIcon",
    "data-sentry-source-file": "PurchaseCompleteBenefitIcon.tsx"
  });
}